import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { Teleton_Title } from '../../../../../utils/ES/Modals/SocialModals';

const ModalSocialTeleton = () => {
  return (
    <>
      <ModalVideo
        id="teleton-social"
        dataText={Teleton_Title}
        videoSrc="https://player.vimeo.com/video/254769250?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        videoTitle="KUTER_STUDIO_TELETON"
      />
    </>
  );
};

export default ModalSocialTeleton;
